import React from 'react'
import tw from 'twin.macro'
import Image from 'src/assets/images/mc-onboarding-welcome.svg'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'

export const CustomerOnboardingCompleted = () => {
  return (
    <div
      css={tw`border border-solid border-[#EDEDED] rounded-2xl p-4 pt-6 w-[426px] bg-white flex flex-col items-center`}
    >
      <img src={Image} />
      <Typography css={tw`my-2 text-center`} variant="h4">
        Your account has been created!
      </Typography>
      <Typography css={tw`text-center`} variant="body2" color={colors.SHADES_GREY_400}>
        Thank you for completing the onboarding process! Our team will be in touch soon to help you
        finalize your GigSafe account setup.
      </Typography>
      <Typography css={tw`mt-8 mb-4 text-center`} variant="body2" color={colors.SHADES_GREY_400}>
        If you have any urgent questions, feel free to contact us at &nbsp;
        <a
          data-testid="customer-account-onboarding-completed-help-link"
          css={tw`no-underline`}
          href="mailto:help@gigsafe.com"
          target="_blank"
        >
          <Typography
            css={tw`cursor-pointer inline-block hover:text-[rgba(95, 0, 191, 1)]`}
            variant="body2"
            color={colors.PRIMARY_PURPLE_500}
          >
            help@gigsafe.com
          </Typography>
        </a>
        .
      </Typography>
    </div>
  )
}
